module.exports = __webpack_public_path__ + "./fonts/DMSans-MediumItalic.62de8a.eot";